import { useState } from 'react'
import MentionTextarea from '../../components/ui/MentionTextarea'
import s from '../../styles/pages/DiscussionDetailPage.module.css'

export default function ReplyComposer({ onSubmit, onCancel, placeholder = 'Write a reply...', discussionId }: {
  onSubmit: (content: string) => Promise<void>; onCancel: () => void; placeholder?: string; discussionId?: string
}) {
  const [text, setText] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (!text.trim() || submitting) return
    setSubmitting(true)
    try { await onSubmit(text.trim()); setText('') } finally { setSubmitting(false) }
  }

  return (
    <div className={s.replyComposer}>
      <MentionTextarea
        value={text}
        onChange={setText}
        placeholder={placeholder}
        rows={2}
        autoFocus
        discussionId={discussionId}
        allowAgentMentions={!!discussionId}
        onKeyDown={(e) => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) void handleSubmit() }}
      />
      <div className={s.replyComposerActions}>
        <button onClick={onCancel} className={s.replyComposerCancel}>Cancel</button>
        <button onClick={() => void handleSubmit()} disabled={!text.trim() || submitting}
          className={`${s.replyComposerSubmit} ${text.trim() && !submitting ? s.ready : s.disabled}`}>
          {submitting ? '...' : 'Reply'}
        </button>
      </div>
    </div>
  )
}
